export class SearchCriteria {
    pageNumber?: number;
    pageSize? : number;
    sortColumn?: string;
    sortDirection?: string;
}

